import { render, staticRenderFns } from "./ClinicOnLineTableCmp4.vue?vue&type=template&id=5eb20b19&"
import script from "./ClinicOnLineTableCmp4.vue?vue&type=script&lang=js&"
export * from "./ClinicOnLineTableCmp4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports